import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SubscriptionClass;
function Subscription() {
  if (SubscriptionClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Subscription');
    SubscriptionClass = $;
  }
  return SubscriptionClass;
}
//region block: exports
export {
  Subscription as Subscription2xxf73xmsvgi0,
};
//endregion

//# sourceMappingURL=Subscription.mjs.map
